export default "__VITE_ASSET__C6wxO9uO__"